<template>
    <section class="padding-vertical-content" key="paso2" id="paso2">
        <ContentOrLoading :style="loading ? 'padding: 200px;' : ''">
            <div class="container" v-if="!loading">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</h2>
                        <h3 class="subtitle h3 light mb-3 " v-if="!select_disabled">{{ $t('nuevo_abono.varios_asientos') }}</h3>
                        <button @click="volver" class="h6 button small-button mr-0" :disabled="disabled"> <i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="row">
                            <div class="col-12">
                                <div class="oswald text-uppercase">{{ $t('nuevo_abono.zona_seleccionada') }}:</div>
                                <span class="h3 mb-4 mb-lg-2 d-flex justify-content-between align-items-end">
                                    {{ zona.name }}
                                </span>
                                <ImagenPanoramica v-if="zona.imagen_panoramica" name="imagen-panoramica" :url="zona.imagen_panorama" title="Imagen panorámica de la zona" v-on:close="() => close()"/>
                                <div v-if="zona.imagen && !mostrarCambiarZona" class="mb-3">
                                    <img v-lazy="zona.imagen"/>
                                </div>
                                <button v-if="zona.imagen_panoramica" @click="showModal('imagen-panoramica')" type="button" class="h6 button small-button m-0 mrgn_360">VER 360º</button>

                                <SelectorZonaComponent v-if="mostrarCambiarZona" :zona="zona" :zonas="zonas" v-on:cambiarZona="cambiarZona"/>
                                <TusAsientosComponent  
                                    v-if="zona.with_seats && !loading" 
                                    :key="reloadComponent"
                                    :precios="zona.precios" 
                                    :asientos="datos_compradores_temp" 
                                    v-on:continuar="bloquearAsientos" 
                                    :can_click="disabled ? false : true" 
                                    :configuracion_valida="true"
                                    :AsientosValidos="AsientosValidos"
                                />
                            </div>
                        </div>                            
                    </div>
                    <div class="col-12 col-lg-8 order-first order-lg-last">
                        <div v-if="zona.with_seats">
                            <template v-if="zona.lfp_id">
                                <AsientosLfpComponent 
                                    :key="reloadComponent"
                                    :zona="zona" 
                                    :asientos="asientos_temp" 
                                    v-on:actualizarDatos="actualizarDatos" 
                                    v-on:continuar="bloquearAsientos" 
                                    :can_click="disabled ? false : true" 
                                    :forzar_adyacentes="false"
                                    @cargado="loading = false"
                                />
                            </template>
                            <template v-else>
                                <AsientosComponent 
                                    :key="reloadComponent"
                                    :zona="zona" 
                                    :asientos="asientos_temp" 
                                    v-on:actualizarDatos="actualizarDatos" 
                                    v-on:continuar="bloquearAsientos" 
                                    :can_click="disabled ? false : true" 
                                    :forzar_adyacentes="false"
                                    @cargado="loading = false"
                                    @AsientosValidos="asientosValid"
                                />
                            </template>
                        </div>
                        <div v-if="!zona.with_seats">
                            <p class="oswald text-uppercase mt-lg-4">{{ $t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos}) }}</p>
                            <div class="form-group">
                                <multiselect
                                    :disabled="select_disabled"
                                    v-model="n_abonos"
                                    :placeholder="$t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos})"
                                    :show-labels="false"
                                    :options="options"
                                    :allow-empty="false"
                                />
                            </div>
                            <TusAsientosComponent 
                                :precios="zona.precios" 
                                :asientos="datos_compradores_temp" 
                                v-on:continuar="bloquearAsientos" 
                                :can_click="disabled ? false : true" 
                                :configuracion_valida="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ContentOrLoading>
    </section>
</template>

<script>
    import ImagenPanoramica from "@/components/common/ImagenPanoramica";
    import SelectorZonaComponent from '@/components/frontend/abonos/nuevo/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/frontend/abonos/nuevo/TusAsientosComponent';
    import AsientosLfpComponent from '@/components/frontend/abonos/nuevo/AsientosLfpComponent';
    import AsientosComponent from '@/components/frontend/abonos/nuevo/AsientosComponent';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            asientos: {
                type: Array,
                required: true
            },
            datos_compradores: {
                type: Array,
                required: true
            },
        },
        data() {
            return{
                AsientosValidos: true,
                mostrarCambiarZona: false,
                reloadComponent: 1,
                loading: false,
                datos_compradores_temp: null,
                asientos_temp: null,
                n_abonos: 0
            }
        },
        created() {
            this.datos_compradores_temp = [...this.datos_compradores];
            this.asientos_temp = [...this.asientos];
            if(this.$route.query.n_abonado_antiguo != null && this.$route.query.dni && !this.zona.with_seats) {
                this.n_abonos = 1;
            }
        },
        computed: {
            select_disabled() {
                var dni = this.$route.query.dni;
                var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;

                if(dni != null && n_abonado_antiguo != null) {
                    return true;
                } else {
                    return false;
                }
            },
            entradas_disponibles() {
                if (this.zona) {
                    if(this.zona.libres >= 0) {
                        return this.zona.libres;
                    }
        
                    return this.zona.aforo - this.zona.confirmados - this.zona.no_confirmados;
                }

                return 0;
            },
            options() {
                var tope = 10;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        watch: {
            n_abonos() {
                var dni = this.$route.query.dni;
                var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;
                if(dni == null && n_abonado_antiguo == null) {
                    this.asientos_temp = [];
                    this.datos_compradores_temp = [];
                    for (var i = 0; i < this.n_abonos; i++) {
                        this.asientos_temp.push({
                            'apellidos': '',
                            'dni': '',
                            'es_nuevo': true,
                            'nombre': '',
                            'precio': null,
                            'precios': this.zona.precios,
                            'tipos_abonos': this.zona.tipos_abonos,
                            'telefono': '',
                            'url_imprimir': '',
                            'asiento': {
                                'zona_id': this.zona.id
                            }
                        });
                        this.datos_compradores_temp.push({
                            'apellidos': '',
                            'dni': '',
                            'es_nuevo': true,
                            'nombre': '',
                            'precio': null,
                            'precios': this.zona.precios,
                            'tipos_abonos': this.zona.tipos_abonos,
                            'telefono': '',
                            'url_imprimir': '',
                            'asiento': {
                                'zona_id': this.zona.id
                            }
                        });
                    }
                }
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            close(modal) {
                this.$modal.hide(modal);
            },
            cambiarZona(zona) {
                this.$emit('cambiarZona', zona);
                this.mostrarCambiarZona = false;
            },
            actualizarDatos(datos) {
                this.datos_compradores_temp = datos;
                this.$emit('fillDatosComprador', this.datos_compradores_temp, null);
            },
            asientosValid(data){
                this.AsientosValidos = data;
            },
            volver() {
                if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.$emit('volver');
                }
            },
            bloquearAsientos() {
                this.$emit('asientosSeleccionados', this.datos_compradores_temp, this.asientos_temp);
            }
        },
        components: {
            ImagenPanoramica, SelectorZonaComponent, TusAsientosComponent, AsientosLfpComponent, AsientosComponent
        }
    }
</script>

<style scoped>
    .mrgn_360 {
        margin-right: 8px !important;
        height: 52px;
        width: 80px
    }

    .mrgn_ver {
        margin-left: 8px !important;
        height: 52px;
        width: 80px
    }

    @media (max-width: 768px) {
        .mrgn_360 {
            margin-right: auto;
        }

        .mrgn_ver {
            margin-left:auto;
        }
    }
</style>